import { z } from 'zod';
import { DocumentType } from './enums.js';

export const RoutingStep = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('role'), roleId: z.string().min(1), label: z.string().min(1) }),
  z.object({
    kind: z.literal('managerial'),
    label: z.string().min(1),
    startFrom: z.literal('submitter'),
    stopWhen: z.literal('approvalLimitCoversAmount'),
    // VERIFY against Legends' design (spec 21: default lastRetrieved)
    assign: z.enum(['lastRetrieved', 'allRetrieved']).default('lastRetrieved'),
  }),
]);
export type RoutingStep = z.infer<typeof RoutingStep>;

export const RoutingConfig = z.object({
  documentTypes: z.array(
    z.object({
      type: DocumentType,
      inScope: z.boolean(),
      steps: z.array(RoutingStep),
      escalationRoleId: z.string().min(1),
    }),
  ),
});
export type RoutingConfig = z.infer<typeof RoutingConfig>;

const managerial = (label: string): RoutingStep => ({
  kind: 'managerial',
  label,
  startFrom: 'submitter',
  stopWhen: 'approvalLimitCoversAmount',
  assign: 'lastRetrieved',
});

/** Seed routing config (spec section 10.2). */
export const SEED_ROUTING_CONFIG: RoutingConfig = {
  documentTypes: [
    {
      type: 'PurchaseRequisition',
      inScope: true,
      steps: [managerial('Managerial approval')],
      escalationRoleId: 'LEDGERFINANCIALCONTROLLER',
    },
    {
      type: 'PurchaseOrder',
      inScope: true,
      steps: [managerial('Managerial approval')],
      escalationRoleId: 'LEDGERFINANCIALCONTROLLER',
    },
    {
      type: 'VendorInvoice',
      inScope: true,
      steps: [
        { kind: 'role', roleId: 'VENDINVOICEACCOUNTSPAYABLEMANAGER', label: 'AP review' },
        managerial('Amount approval'),
      ],
      escalationRoleId: 'LEDGERFINANCIALCONTROLLER',
    },
    {
      type: 'Journal',
      inScope: true,
      steps: [{ kind: 'role', roleId: 'LEDGERACCOUNTINGMANAGER', label: 'GL approval' }],
      escalationRoleId: 'LEDGERFINANCIALCONTROLLER',
    },
  ],
};
